import styles from './styles.scss';
import { IconArrow } from 'components/Shared/Icon/themes/BGH-RD3/iconArrow';
import { IconPhoneCalling } from 'components/Shared/Icon';
import { IconPhone } from 'components/Shared/Icon/themes/BGH-RD3/iconPhone';
import { NO_ELEMENT } from 'utils';
import connect from 'components/Shared/connect';
import { HeaderModel } from 'models/HeaderModel';
import { isTablet, isDesktopLayout, isHuge } from 'components/Shared/responsive';
import { useState } from 'react';
import { ContactBlock as ContactBlockModel } from 'models/ContactSection';
import { useSelector } from 'react-redux';
import cn from 'classnames';
import { PhoneButton } from 'components/ContactInfo/themes/BGH/phoneButton';
import {
  selectBlackFridayStatus,
  selectHelpCenterStatus
} from 'components/Header/themes/BGH/selector';

type MergedProps = Required<Pick<HeaderModel, 'contactSection'>> & {
  isDesktop: boolean;
};

const ContactBlock = ({ title, subTitle, uspTitle, usps, phoneNumber }: ContactBlockModel) => (
  <div key={title} className={styles.section}>
    <h4 className={styles.sectionHeading}>{title}</h4>
    <p className={styles.openingHours}>{subTitle}</p>
    <p className={styles.listHeading}>{uspTitle}</p>
    <ul className={styles.list}>
      {usps.map(usp => (
        <li key={usp}>{usp}</li>
      ))}
    </ul>
    <PhoneButton phoneNumber={phoneNumber} />
  </div>
);

const _ContactInfo = ({ isDesktop, contactSection }: MergedProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const open = () => {
    isDesktop && setIsOpen(true);
  };

  const close = () => {
    isDesktop && setIsOpen(false);
  };
  const { contactUrl, mobileTitle, title, blocks, isCritical, message } = contactSection;
  const blackFridayIsActive = useSelector(selectBlackFridayStatus);
  const shouldUseHelpCenter = useSelector(selectHelpCenterStatus);
  let tmpBlocks = blocks;
  if (shouldUseHelpCenter) {
    tmpBlocks = blocks.slice(0, 1);
  }
  return (
    <div className={styles.contactInfo} onMouseEnter={open} onMouseLeave={close}>
      <div className={styles.tabletDesktop}>
        <IconPhone className={styles.phoneIcon} />
        <a href={contactUrl} className={styles.tagline}>
          {title}
        </a>
        <IconArrow className={styles.arrowIcon} size="small" appearance="flip-90" />
      </div>
      <div className={styles.mobile}>
        <a className={styles.phoneIconMobile} href={`tel:${blocks[0]?.phoneNumber}`}>
          {/* Adding a hidden nbr so GTM can find and replace the phone nbr in the href with a Google Forwarding Number */}
          <span style={{ display: 'none' }}>{blocks[0]?.phoneNumber}</span>
          <IconPhoneCalling />
          <span>{mobileTitle}</span>
        </a>
      </div>
      <div
        className={cn(styles.dropdownWrapper, {
          [styles.isOpen]: isOpen,
          [styles.blackFriday]: blackFridayIsActive
        })}
      >
        {message && (
          <div className={isCritical ? styles.criticalMessage : styles.normalMessage}>
            {message}
          </div>
        )}

        {tmpBlocks.map(block => (
          <ContactBlock {...block} key={block.title} />
        ))}
      </div>
    </div>
  );
};

export const ContactInfo = connect(state => ({
  contactSection: state.header.contactSection,
  isDesktop: isTablet(state) || isDesktopLayout(state) || isHuge(state)
}))(_ContactInfo);

export const ContactInfoBox = () => NO_ELEMENT;
